import { KonvaEventObject } from 'konva/lib/Node'
import { useIntl } from 'react-intl'
import { Circle, Group, Line } from 'react-konva'
import { AnnotationLabel } from '../AnnotationLabel'

const CIRCLE_SIZE = 4

type PolygonInProgressProps = {
  color: string
  points: number[][]
  flattenedPoints: number[]
  onMouseOverStartPoint: (e: KonvaEventObject<MouseEvent>) => void
  onMouseOutStartPoint: (e: KonvaEventObject<MouseEvent>) => void
}

export const PolygonInProgress = ({
  color,
  points,
  flattenedPoints,
  onMouseOverStartPoint,
  onMouseOutStartPoint
}: PolygonInProgressProps) => {
  const intl = useIntl()

  const labelPos = {
    x: flattenedPoints[flattenedPoints.length - 2],
    y: flattenedPoints[flattenedPoints.length - 1] - 20
  }

  return (
    <Group>
      <Line points={flattenedPoints} stroke={color} strokeWidth={2} />

      {points.map((point, index) => {
        const x = point[0] - 1
        const y = point[1] - 1

        const startPointAttr =
          index === 0
            ? {
                hitStrokeWidth: 12,
                onMouseOver: onMouseOverStartPoint,
                onMouseOut: onMouseOutStartPoint
              }
            : null

        return (
          <Circle
            key={index}
            x={x}
            y={y}
            radius={CIRCLE_SIZE}
            fill="white"
            stroke={color}
            strokeWidth={2}
            {...startPointAttr}
          />
        )
      })}

      {flattenedPoints.length === 2 && (
        <AnnotationLabel
          x={labelPos.x}
          y={labelPos.y}
          color="rgba(0,0,0,0.6)"
          textColor="white"
          text={intl.formatMessage({ id: 'logic.annotate.setStartPosition' })}
        />
      )}
    </Group>
  )
}
